module.exports = __webpack_public_path__ + "img/avatar.5c072037.jpg";